import { cx } from './cx'

/** Served from `public/`, so it is part of the bundle rather than a request to
 * the marketing site. The portal hotlinks its logo from WordPress; an app behind
 * the firm's VPN should not have a blank header because a CMS is down. */
const LOGO = '/dwap-logo.webp'

/**
 * The firm's mark and the product name, locked up together.
 *
 * The seal carries "Divorce with a Plan" in arched type, which is illegible at
 * the size a sidebar allows — so the name is set as text beside it and the image
 * is left decorative. A screen reader gets the name once, from the text, rather
 * than twice.
 *
 * On the indigo sidebar the navy seal sits on a white disc. The artwork is
 * transparent and circular, so a disc reads as intended rather than as a
 * pasted-on rectangle, and it is the only way the mark stays legible against a
 * background close to its own colour.
 */
export function Wordmark({
  tone = 'light',
  className,
}: {
  /** `light` for the indigo sidebar, `dark` for a white background. */
  tone?: 'light' | 'dark'
  className?: string
}) {
  const name = tone === 'light' ? 'text-white' : 'text-brand-900'
  const sub = tone === 'light' ? 'text-brand-300' : 'text-ink-600'

  return (
    <div className={cx('flex items-center gap-2.5', className)}>
      <img
        src={LOGO}
        alt=""
        aria-hidden
        width={36}
        height={36}
        className={cx(
          'size-9 shrink-0 rounded-full object-contain',
          tone === 'light' && 'bg-white p-0.5'
        )}
      />
      <span className="min-w-0">
        <span className={cx('block font-display text-[15px] leading-tight font-semibold', name)}>
          Divorce with a Plan
        </span>
        <span className={cx('block text-[10px] tracking-[0.16em] uppercase', sub)}>
          Finance Platform
        </span>
      </span>
    </div>
  )
}
